import {
  Banknote, Wallet, CreditCard, ArrowLeftRight, CalendarClock, Cog, Building2,
  ShieldCheck, Users, FileCheck2, Timer, BellRing, HeartHandshake, BadgeCheck,
  Landmark, Factory, Package, Layers, Car, Wrench, Store, UtensilsCrossed,
  Printer, Ship, Truck, ShoppingBag, Pill,
} from "lucide-react";

export const CONTACT = {
  phone: "+91-9990290903",
  phoneRaw: "919990290903",
  email: "work@apexcreditagency.in",
  whatsapp: "https://wa.me/919990290903?text=Hi%20Apex%20Credit%20Solutions%2C%20I%20want%20to%20know%20about%20business%20loans",
  location: "Delhi NCR, India",
};

export const NAV_LINKS = [
  { label: "Home", id: "hero" },
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why-us" },
  { label: "Process", id: "process" },
  { label: "Testimonials", id: "testimonials" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export const STATS = [
  { value: 150, suffix: "+", label: "Satisfied Businesses" },
  { value: 10, suffix: "+", label: "MSME Loan Disbursements" },
  { value: 3, suffix: "", label: "Cases Under Process" },
];

export const PARTNERS = [
  "HDFC Bank", "ICICI Bank", "Axis Bank", "Kotak Mahindra", "Bajaj Finserv",
  "Tata Capital", "Yes Bank", "IDFC First", "Aditya Birla Finance", "Poonawalla Fincorp",
];

export const WHY_US = [
  { icon: Banknote, title: "Funding up to ₹5 Crore", desc: "Sizeable facilities structured to match your growth ambitions." },
  { icon: Landmark, title: "Multiple Banking Partners", desc: "A wide lender network to find your best-fit offer." },
  { icon: Users, title: "Dedicated Relationship Manager", desc: "One point of contact from enquiry to disbursement." },
  { icon: ShieldCheck, title: "Transparent Process", desc: "No surprises. Clear terms and honest guidance throughout." },
  { icon: FileCheck2, title: "Documentation Support", desc: "Professional help preparing a lender-ready file." },
  { icon: BadgeCheck, title: "Quick Eligibility Assessment", desc: "Know where you stand within minutes, not weeks." },
  { icon: BellRing, title: "Regular Updates", desc: "Proactive status updates at every milestone." },
  { icon: HeartHandshake, title: "End-to-End Assistance", desc: "We stay with you until the funds are in your account." },
  { icon: Timer, title: "No Hidden Charges", desc: "Straightforward pricing you can plan around." },
];

export const SERVICES = [
  { icon: Banknote, title: "Business Loan", desc: "Unsecured funding to fuel operations, hiring and growth." },
  { icon: CreditCard, title: "Cash Credit", desc: "Revolving limits to keep your working capital cycle smooth." },
  { icon: ArrowLeftRight, title: "Overdraft", desc: "Flexible drawdowns for short-term liquidity gaps." },
  { icon: Wallet, title: "Working Capital", desc: "Fund inventory, receivables and day-to-day operations." },
  { icon: CalendarClock, title: "Term Loan", desc: "Structured repayment for planned capital expenditure." },
  { icon: Cog, title: "Machinery Finance", desc: "Acquire new equipment without straining cash reserves." },
  { icon: Building2, title: "Loan Against Property", desc: "Unlock value from commercial property for business use." },
];

export const PROCESS = [
  { step: "01", title: "Business Discussion", desc: "We understand your business, goals and funding requirement." },
  { step: "02", title: "Eligibility Check", desc: "A quick assessment of turnover, vintage and financials." },
  { step: "03", title: "Documentation", desc: "We help you assemble a clean, lender-ready file." },
  { step: "04", title: "Bank Processing", desc: "Applications placed with best-fit banking partners." },
  { step: "05", title: "Sanction", desc: "Terms negotiated and sanction letter secured." },
  { step: "06", title: "Disbursement", desc: "Funds credited so you can get back to growing." },
];

export const CASE_STUDIES = [
  { type: "Manufacturing Company", product: "Working Capital", amount: "₹80 Lakhs", tag: "Approved" },
  { type: "Packaging Unit", product: "Cash Credit", amount: "₹1.25 Crore", tag: "Approved" },
  { type: "Engineering Company", product: "Business Loan", amount: "₹2.1 Crore", tag: "Approved" },
];

export const TESTIMONIALS = [
  { name: "Rajesh Malhotra", role: "Director, Precision Auto Parts", quote: "Professional and transparent from day one. Our working capital limit came through faster than we expected.", img: "https://images.unsplash.com/photo-1649433658557-54cf58577c68?w=200" },
  { name: "Anita Verma", role: "Founder, Verma Packaging", quote: "They handled the entire documentation and kept us updated at every step. Truly hassle-free financing.", img: "https://images.pexels.com/photos/7580822/pexels-photo-7580822.jpeg?w=200" },
  { name: "Suresh Iyer", role: "CEO, Iyer Engineering Works", quote: "Reliable advisors who understand MSME realities. We got a ₹2 Crore facility on fair terms.", img: "https://images.unsplash.com/photo-1600180758890-6b94519a8ba6?w=200" },
  { name: "Neha Kapoor", role: "Partner, Kapoor Foods", quote: "Fast, reliable and genuinely helpful. Highly recommend for any growing MSME in Delhi NCR.", img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200" },
];

export const INDUSTRIES = [
  { icon: Factory, label: "Manufacturing" }, { icon: Package, label: "Packaging" },
  { icon: Layers, label: "Plastic" }, { icon: Car, label: "Automobile" },
  { icon: Wrench, label: "Engineering" }, { icon: Store, label: "Wholesale" },
  { icon: UtensilsCrossed, label: "Food" }, { icon: Printer, label: "Printing" },
  { icon: Ship, label: "Export" }, { icon: Truck, label: "Logistics" },
  { icon: ShoppingBag, label: "Retail Chains" }, { icon: Pill, label: "Pharma" },
];

export const FAQS = [
  { q: "What loan amount can Apex Credit Solutions help me raise?", a: "We assist MSMEs in securing facilities of up to ₹5 Crore across business loans, working capital, cash credit, overdraft, term loans, machinery finance and loan against property." },
  { q: "Who is eligible for a business loan?", a: "Typically established MSMEs with an annual turnover of ₹1 Crore or more. Exact eligibility depends on business vintage, GST filings, ITRs and banking conduct." },
  { q: "How long does the process take?", a: "Timelines vary by lender and product, but a well-documented file can move from eligibility check to disbursement within a few working days to a couple of weeks." },
  { q: "What documents are required?", a: "Generally KYC, GST returns, bank statements, ITRs and financial statements. Our team helps you assemble a complete, lender-ready file." },
  { q: "Do you charge any upfront fees?", a: "We believe in transparent, no-hidden-charge engagements. Any applicable charges are disclosed upfront before you proceed." },
  { q: "Which banks and NBFCs do you work with?", a: "We work with multiple banking partners and NBFCs, allowing us to shop your profile for the best-fit offer." },
  { q: "Can I get funding without collateral?", a: "Yes. Unsecured business loans and working capital facilities are available for eligible businesses based on financial strength and banking conduct." },
  { q: "What is the difference between cash credit and overdraft?", a: "Both are revolving facilities. Cash credit is typically secured against inventory/receivables, while an overdraft is often linked to your current account and collateral." },
  { q: "Do you help with machinery finance?", a: "Absolutely. We arrange financing to purchase new plant and machinery so you can expand capacity without draining cash reserves." },
  { q: "Which industries do you serve?", a: "Manufacturing, packaging, plastics, automobile, engineering, wholesale, food processing, printing, export, logistics, retail chains and pharma, among others." },
  { q: "Is a good credit score mandatory?", a: "A healthy credit profile helps, but eligibility is assessed holistically. We guide you on strengthening your profile where needed." },
  { q: "Can I prepay or foreclose my loan?", a: "Most lenders allow prepayment or foreclosure, subject to their terms. We help you understand these before you sign." },
  { q: "Will you handle communication with the bank?", a: "Yes. Your dedicated relationship manager coordinates with lenders and keeps you updated at every milestone." },
  { q: "Do you serve businesses outside Delhi NCR?", a: "Our core focus is Delhi NCR, and we evaluate opportunities from established MSMEs elsewhere on a case-by-case basis." },
  { q: "How do I get started?", a: "Book a free consultation, call, or message us on WhatsApp. We'll assess your eligibility and outline the best funding path for you." },
];

export const TURNOVER_OPTIONS = ["₹1 Cr – ₹2 Cr", "₹2 Cr – ₹5 Cr", "₹5 Cr – ₹10 Cr", "₹10 Cr+"];
export const VINTAGE_OPTIONS = ["Less than 1 year", "1 – 3 years", "3 – 5 years", "5+ years"];
export const YESNO = ["Yes", "No"];
export const LOAN_NEED_OPTIONS = ["Up to ₹25 Lakhs", "₹25 – ₹50 Lakhs", "₹50 Lakhs – ₹1 Crore", "₹1 – ₹3 Crore", "₹3 – ₹5 Crore"];
